jQuery(document).ready(function(e) {
  var a, t = e(".header-full"),
      o = e(".menu-mobile-btn");
  0 < t.length && 0 < e(".home-full").length && ((a = function() {
      100 < e(window).scrollTop() ? (t.addClass("active"), o.removeClass("full")) : (t.removeClass("active"), o.addClass("full"))
  })(), e(window).on("scroll", debounce(function() {
      a()
  }, 10)))
}),
function() {
  var e = $(".menu-mobile-btn"),
      a = $("#menu-mobile"),
      t = $(".menu-mobile-wrapper"),
      o = $("#menu-mobile .has-sub"),
      n = $("#menu-mobile .go-back"),
      r = $("body");

  function i() {
      r.removeClass("scroll-disabled"), e.removeClass("active"), a.removeClass("active"), a.find("ul").not(".menu-mobile-nav").addClass("is-hidden"), a.find("ul").removeClass("move-left"), a.find("ul").scrollTop(0)
  }
  0 < $(".menu-mobile-btn-wrap").length && $(".menu-mobile-btn").css("left", $(".menu-mobile-btn-wrap").offset().left - 35), e.on("click", function() {
      a.hasClass("active") ? i() : (r.addClass("scroll-disabled"), e.addClass("active"), a.addClass("active"), a.find("ul").scrollTop(0))
  }), t.on("click", function(e) {
      e.target == this && i()
  }), o.children("a").on("click", function(e) {
      e.preventDefault(), $(this).parent().parent().addClass("move-left"), $(this).parent().children("ul").removeClass("is-hidden"), a.find("ul").scrollTop(0)
  }), n.children("a").on("click", function(e) {
      e.preventDefault(), $(this).parent().parent().parent().parent().removeClass("move-left"), $(this).parent().parent().addClass("is-hidden"), a.find("ul").scrollTop(0)
  })
}();